import React from "react";
import iphoneLeft from "../landing-page/images/iphone-left.png";
import phoneMockup from "../landing-page/images/phone-mockup.png";
import appleStore from "../landing-page/images/app-store-ic.svg";
import googlePlay from "../landing-page/images/google-pay-ic.svg";
import "../landing-page/css/style.css";
const UniqueSection = () => {
  return (
    <div
      className="unique-sec wow fadeInUp"
      style={{ visibility: "visible", animationName: "fadeInUp" }}
    >
      <div className="fixed-wrapper">
        <div className="unique-outer">
          <div className="uniuq-box">
            <h4>
              unique and creative bets using <br /> TXTBET – make every moment
              more exciting!
            </h4>
            <ul className="list-icon">
              <li>Winner takes the loser out for dinner.</li>
              <li>Determine who does what chores this week.</li>
              <li>
                Loser shaves their head and takes out the garbage for 2 weeks.
              </li>
              <li>With TXTBET anything is possible </li>
            </ul>
            <figure>
              <img src={iphoneLeft} alt="" />
            </figure>
          </div>

          <div className="uniuq-box dark-blue">
            <h4>Let TXTBET keep you connected.</h4>
            <p>
              TXTBET is the perfect app to engage with family and friends to
              provide entertainment and excitement and help bring you all
              together.
            </p>
            <div className="blue-box-inner-txt">
              <p>
                Whether on the same couch or across the world TXTBET is a fun
                app that will bring excitement to the everyday relationships we
                have.
              </p>

              <ul>
                <li>
                  <h3>
                    15k+<span>Morbi in sem quis </span>
                  </h3>
                </li>
                <li>
                  <h3>
                    100 <span>Morbi in sem quis </span>
                  </h3>
                </li>
                <li>
                  <h3>
                    1M+ <span>Morbi in sem quis </span>
                  </h3>
                </li>
              </ul>
            </div>
            <figure>
              <img src={phoneMockup} alt="" />
            </figure>
          </div>
        </div>

        <div className="download-btn">
          <h2 className="!text-[22px] sm:!text-[40px] !font-bold 2xl:!text-[56px] xl:!text-[56px] lg:!text-[46px] md:!text-[46px]">
            Download Our <span>Mobile App</span>
          </h2>
          <ul className="btn-list">
            <li>
              <a href="#">
                <img src={appleStore} alt="" />
              </a>
            </li>
            <li>
              <a href="#">
                <img src={googlePlay} alt="" />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default UniqueSection;
